import * as ewe from "@eyeo/webext-ad-filtering-solution";
import { Prefs } from "../../alias/prefs";
import { LogLevel } from "./logger.types";
function log(level, fn, ...data) {
    const minLevel = Prefs.get("logger_log_level");
    if (level < minLevel) {
        return;
    }
    fn(...data);
}
export const debug = log.bind(null, LogLevel.debug, console.debug);
export const error = log.bind(null, LogLevel.error, console.error);
export const info = log.bind(null, LogLevel.info, console.info);
export const warn = log.bind(null, LogLevel.warn, console.warn);
export function reportAndLogError(e, logContext) {
    if (e instanceof Error) {
        ewe.sentry.reportError(e);
    }
    if (logContext) {
        error(logContext, e);
    }
    else {
        error(e);
    }
}
